import { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

export const GlossaryContext = createContext([]);

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Mirrors main/manual_html.py, which does the same for rich text.
const GlossaryText = ({ text = '' }) => {
    const terms = useContext(GlossaryContext);

    const pattern = useMemo(() => {
        if (!terms.length) {
            return null;
        }

        const alternatives = terms.map(escapeRegExp).join('|');
        // Surrounding spaces and punctuation go inside the span, since browser
        // translation drops them next to text it leaves untranslated.
        return new RegExp(
            `(\\s?[^\\p{L}\\p{N}_\\s]*(?<![\\p{L}\\p{N}_])(?:${alternatives})(?![\\p{L}\\p{N}_])[^\\p{L}\\p{N}_\\s]*\\s?)`,
            'iu'
        );
    }, [terms]);

    if (!pattern || !text) {
        return text;
    }

    return text.split(pattern).map((part, index) =>
        index % 2 ? (
            <span key={index} translate="no">
                {part}
            </span>
        ) : (
            part
        )
    );
};

GlossaryText.propTypes = {
    text: PropTypes.string,
};

export default GlossaryText;
